export default "__VITE_ASSET__C_wka7WB__"